/**
 * DSP Push workflow
 */

import { useCallback } from 'react';
import { Step, Workflow } from './Workflow';
import useFeature from 'hooks/useFeature';

const useDspPushWorkflow = () => {
  const { isEnabled } = useFeature();

  const getWorkflow = useCallback((): Workflow => {
    if (!isEnabled('dspPush')) {
      throw new Error(`Workflow 'dspPush' not supported for this tenant`);
    }
    return {
      stepsEnabled: {
        [Step.DSP_START]: true,
      },
      paths: {
        [Step.DSP_START]: '/dsp-start',
      },
      progressStartStep: Step.DSP_START,
      restartStep: Step.DSP_START,
      timeoutRestartPath: '/dsp-start',
    };
  }, [isEnabled]);
  return getWorkflow;
};

export default useDspPushWorkflow;
